<template>
  <svg fill="none" :class="`icon-${size}`" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.22606 8.71106H16.2312C18.5886 8.71106 20.5 10.5807 20.5 12.8866V17.8245C20.5 20.1304 18.5886 22 16.2312 22H7.76778C5.41136 22 3.5 20.1304 3.5 17.8245V12.8866C3.5 10.9902 4.80066 9.40682 6.57077 8.89792L6.46001 8.91084V7.38714C6.48033 4.41626 8.95057 2 11.9787 2C14.3463 2 16.4385 3.46208 17.2108 5.62787C17.2921 5.84654 17.2717 6.08508 17.1701 6.29381C17.0685 6.50253 16.8866 6.66156 16.662 6.73213C16.2048 6.89017 15.6967 6.65262 15.524 6.19541C15.0057 4.72339 13.5842 3.73939 11.999 3.73939C9.92505 3.73939 8.24943 5.37044 8.23825 7.36726V8.70907L8.22606 8.71106ZM11.9949 17.3285C12.4928 17.3285 12.8891 16.9409 12.8891 16.4538V14.2473C12.8891 13.7702 12.4928 13.3826 11.9949 13.3826C11.5072 13.3826 11.1109 13.7702 11.1109 14.2473V16.4538C11.1109 16.9409 11.5072 17.3285 11.9949 17.3285Z" fill="currentColor" />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
  size: { type: Number, default: 20 }
})
</script>
